import React, { useRef } from "react";
import styles from "./CheckBox.module.scss";

const CheckBox = (props) => {
  const checkboxRef = useRef();

  const handleOnChange = () => {
    checkboxRef.current.onChange();
  };

  const hideCheckbox = props.hideCheckbox ? styles.checkboxHidden : "";
  const checkboxStyle = props.boldCheck ? styles.bold : "";

  return (
    <div className={`${hideCheckbox} ${styles.checkboxContainer}`}>
      <div className={styles.checkboxWrapper}>
        <input
          disabled={props.isDisabled}
          type="checkbox"
          ref={checkboxRef}
          id={props.id}
          className={`${styles.checkbox} ${checkboxStyle}`}
          onChange={(e) => props.onChange(e)}
          data-testid={props.id}
          checked={props.checked}
          value={props.value}
        />
        <label htmlFor={props.id} onClick={() => handleOnChange} />
      </div>
      {props.labelList && props.labelList.length > 0 ? (
        <div>
          <div className={styles.label} data-testid={props.id + "Text"}>
            {props.label}
          </div>
          <ul className={styles.labelList}>
            {props.labelList.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      ) : (
        <div
          className={props.textClass || styles.label}
          data-testid={props.id + "Text"}
        >
          {props.label}
        </div>
      )}
    </div>
  );
};

export default CheckBox;
